import { openMeldRequestContextSchema } from "./profile-identity.js";
import { daemonServiceLaneSchema } from "./service-contract.js";
import { localFolderPathSchema } from "./local-folder-path.js";
import * as z$1 from "zod/v4";
//#region src/schemas/daemon/computer-file-access.ts
const COMPUTER_FILE_ACCESS_OWNER_CANCELLED_REASON_CODE = "computer.file_access.owner_declined";
function isComputerFileAccessOwnerCancellation(payload) {
	return payload.status === "failed" && payload.errorCode === "computer.file_access.owner_declined";
}
const boundedIdentifierSchema = z$1.string().trim().min(1).max(512);
const OPENMELD_RUNTIME_CAPABILITIES_HEADER = "x-openmeld-runtime-capabilities";
const COMPUTER_FILE_ACCESS_RUNTIME_CAPABILITY = "computer-file-access-v1";
const computerFileAccessAbsolutePathSchema = localFolderPathSchema;
const computerFileAccessModeSchema = z$1.enum([
	"local_agent_settings",
	"only_selected_folders",
	"block_selected_folders"
]);
const computerFileAccessDefaultPolicyInputSchema = z$1.strictObject({ mode: z$1.literal("local_agent_settings") });
const computerFileAccessFolderPolicyInputSchema = z$1.strictObject({
	folders: z$1.array(computerFileAccessAbsolutePathSchema).min(1).max(128),
	mode: z$1.enum(["only_selected_folders", "block_selected_folders"])
});
const computerFileAccessPolicyInputSchema = z$1.discriminatedUnion("mode", [computerFileAccessDefaultPolicyInputSchema, computerFileAccessFolderPolicyInputSchema]);
const computerFileAccessPolicyMetadataShape = {
	revision: z$1.number().int().positive(),
	updatedAtMs: z$1.number().int().nonnegative()
};
const computerFileAccessPolicySchema = z$1.discriminatedUnion("mode", [computerFileAccessDefaultPolicyInputSchema.extend(computerFileAccessPolicyMetadataShape), computerFileAccessFolderPolicyInputSchema.extend(computerFileAccessPolicyMetadataShape)]);
const computerFileAccessReadRequestSchema = z$1.strictObject({ expectedDeviceId: boundedIdentifierSchema });
const computerFileAccessUpdateRequestSchema = z$1.strictObject({
	expectedDeviceId: boundedIdentifierSchema,
	expectedRevision: z$1.number().int().positive(),
	idempotencyKey: boundedIdentifierSchema,
	policy: computerFileAccessPolicyInputSchema
});
const computerFileAccessPolicyResponseSchema = z$1.strictObject({
	deviceId: boundedIdentifierSchema,
	policy: computerFileAccessPolicySchema
});
const computerFileAccessErrorCodeSchema = z$1.enum([
	"computer.file_access.device_mismatch",
	"computer.file_access.internal_error",
	"computer.file_access.invalid_request",
	"computer.file_access.invalid_response",
	"computer.file_access.path_not_directory",
	"computer.file_access.path_not_found",
	"computer.file_access.path_unreadable",
	"computer.file_access.revision_mismatch",
	"computer.file_access.service_offline",
	"computer.file_access.service_update_required",
	"computer.file_access.timeout",
	"computer.file_access.unsupported"
]);
const computerFileAccessErrorResponseSchema = z$1.strictObject({
	status: z$1.literal("rejected"),
	code: computerFileAccessErrorCodeSchema,
	message: z$1.string().trim().min(1).max(1024)
});
const computerFileAccessPolicyResultSchema = z$1.union([computerFileAccessPolicyResponseSchema, computerFileAccessErrorResponseSchema]);
const computerFileAccessReadRpcInputSchema = computerFileAccessReadRequestSchema.extend({ context: openMeldRequestContextSchema });
const computerFileAccessUpdateRpcInputSchema = computerFileAccessUpdateRequestSchema.extend({ context: openMeldRequestContextSchema });
const COMPUTER_FILE_ACCESS_FRAME_VERSION = 1;
function defineRequestFrame(code, request) {
	return z$1.strictObject({
		v: z$1.literal(COMPUTER_FILE_ACCESS_FRAME_VERSION),
		code: z$1.literal(code),
		payload: z$1.strictObject({
			requestId: boundedIdentifierSchema,
			request
		})
	});
}
function defineResultFrame(code) {
	return z$1.strictObject({
		v: z$1.literal(COMPUTER_FILE_ACCESS_FRAME_VERSION),
		code: z$1.literal(code),
		payload: z$1.strictObject({
			requestId: boundedIdentifierSchema,
			result: computerFileAccessPolicyResultSchema
		})
	});
}
const computerFileAccessReadRequestFrameSchema = defineRequestFrame("daemon.computer_file_access.read_policy", computerFileAccessReadRequestSchema);
const computerFileAccessReadResultFrameSchema = defineResultFrame("daemon.computer_file_access.read_policy_result");
const computerFileAccessUpdateRequestFrameSchema = defineRequestFrame("daemon.computer_file_access.update_policy", computerFileAccessUpdateRequestSchema);
const computerFileAccessUpdateResultFrameSchema = defineResultFrame("daemon.computer_file_access.update_policy_result");
const computerFileAccessDaemonFrameSchema = z$1.discriminatedUnion("code", [
	computerFileAccessReadRequestFrameSchema,
	computerFileAccessReadResultFrameSchema,
	computerFileAccessUpdateRequestFrameSchema,
	computerFileAccessUpdateResultFrameSchema
]);
const runtimeTransportComputerFileAccessTargetShape = {
	v: z$1.literal(COMPUTER_FILE_ACCESS_FRAME_VERSION),
	ownerUserId: boundedIdentifierSchema,
	deviceId: boundedIdentifierSchema,
	lane: daemonServiceLaneSchema,
	requestId: boundedIdentifierSchema
};
const runtimeTransportComputerFileAccessReadRequestSchema = z$1.strictObject({
	...runtimeTransportComputerFileAccessTargetShape,
	request: computerFileAccessReadRequestSchema
});
const runtimeTransportComputerFileAccessUpdateRequestSchema = z$1.strictObject({
	...runtimeTransportComputerFileAccessTargetShape,
	request: computerFileAccessUpdateRequestSchema
});
//#endregion
export { COMPUTER_FILE_ACCESS_OWNER_CANCELLED_REASON_CODE, COMPUTER_FILE_ACCESS_RUNTIME_CAPABILITY, OPENMELD_RUNTIME_CAPABILITIES_HEADER, computerFileAccessAbsolutePathSchema, computerFileAccessDaemonFrameSchema, computerFileAccessErrorCodeSchema, computerFileAccessErrorResponseSchema, computerFileAccessModeSchema, computerFileAccessPolicyInputSchema, computerFileAccessPolicyResponseSchema, computerFileAccessPolicyResultSchema, computerFileAccessPolicySchema, computerFileAccessReadRequestFrameSchema, computerFileAccessReadRequestSchema, computerFileAccessReadResultFrameSchema, computerFileAccessReadRpcInputSchema, computerFileAccessUpdateRequestFrameSchema, computerFileAccessUpdateRequestSchema, computerFileAccessUpdateResultFrameSchema, computerFileAccessUpdateRpcInputSchema, isComputerFileAccessOwnerCancellation, runtimeTransportComputerFileAccessReadRequestSchema, runtimeTransportComputerFileAccessUpdateRequestSchema };

//# sourceMappingURL=computer-file-access.js.map